import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/contexts';
import { useAgreementValidators } from '~/hooks/useAgreementValidators';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './RenameAgreementModal.module.scss';
export const GetRenameAgreementModalTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            RenameAgreementModalTID: {
                PrimaryButton: 'rename-agr',
                NameInput: 'agr-name'
            }
        }
    });
export const RenameAgreementModal = (props)=>{
    const { currentTitle, renameAgreement, onSuccess, dismissModal } = props;
    const { t: renameModalTexts } = useLocaleKeys('agreement.dashboard.renameModal');
    const { control, formState, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            title: currentTitle
        }
    });
    const { logBI } = useStoreActions();
    const { agreementNameValidation } = useAgreementValidators();
    const { RenameAgreementModalTID } = useMemo(()=>GetRenameAgreementModalTID(), []);
    const renderTitleField = (fieldProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
            bi: {
                name: 'agreement_name'
            },
            collapseHelperText: false,
            autoFocus: true,
            testId: RenameAgreementModalTID.NameInput(),
            label: renameModalTexts.agreementNameLabel()
        }, connectControllerToTextField(fieldProps)));
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'rename_agreement_confirm'
            },
            secondaryButton: {
                name: 'rename_agreement_cancel'
            }
        },
        title: renameModalTexts.title(),
        onCloseButtonClick: dismissModal,
        primaryButtonTestId: RenameAgreementModalTID.PrimaryButton(),
        primaryButtonDisabled: !formState.isDirty,
        primaryButtonLabel: renameModalTexts.save(),
        secondaryButtonLabel: renameModalTexts.cancel(),
        onPrimaryButtonClick: handleSubmit((param)=>{
            let { title } = param;
            renameAgreement(title, ()=>{
                logBI(14050);
                onSuccess(title);
                dismissModal();
            });
        }),
        onSecondaryButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.content,
            children: /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "title",
                rules: agreementNameValidation,
                render: renderTitleField
            })
        })
    });
};
